// TEMPNOTE: This overrides default dev values in environment.ts.
// TEMPNOTE: If you add additional environment files, adjust angular.json's
// TEMPNOTE: configurations list.

export const environment = {
  production: false,
  envName: 'test'
};
